import { FC, useState } from "react";
import { WalletConnectDialog } from "@/components/WalletConnect/WalletConnectDialog";

interface IntroStepProps {
  onBegin: () => void;
  isConnected: boolean;
  title?: string;
}

export const IntroStep: FC<IntroStepProps> = ({
  onBegin,
  isConnected,
  title = "Fund your trading account",
}) => {
  const [walletDialogOpen, setWalletDialogOpen] = useState(false);
  const steps = [
    !isConnected ? "Connect your wallet" : null,
    "Deposit assets",
    "Wait for network confirmation",
    "Start trading once funds are available",
  ].filter((step): step is string => step !== null);

  return (
    <>
      {/* Header */}
      <div className="flex flex-col gap-2 items-center text-center">
        <h1 className="text-2xl sm:text-4xl font-medium text-white">
          {title}
        </h1>
        <p className="text-sm sm:text-base text-sr-pink-muted">
          Deposit assets into your Sugar Rush Trading Vault to start trading.
        </p>
      </div>

      {/* How it works */}
      <div className="w-full flex flex-col gap-3">
        <p className="text-base font-medium text-white">How it works</p>
        <div className="flex flex-col gap-0.5">
          {steps.map((step, index) => {
            const className =
              index === 0
                ? "sr-card-stacked-top"
                : index === steps.length - 1
                  ? "sr-card-stacked-bottom"
                  : "sr-card-stacked-mid";

            return (
              <div key={step} className={className}>
                <ol
                  start={index + 1}
                  className="ml-5 list-decimal text-sm font-medium text-white"
                >
                  <li>{step}</li>
                </ol>
              </div>
            );
          })}
        </div>
      </div>

      {/* Non-custodial callout */}
      <div className="sr-highlight-box w-full">
        <div className="flex flex-col gap-1.5">
          <p className="text-base font-medium text-sr-pink-light">
            Non-custodial by design
          </p>
          <p className="text-xs text-sr-pink-bright">
            Your deposit is protected by broad network consensus, not a single
            exchange operator holding unilateral control of your funds.
          </p>
        </div>
      </div>

      {/* CTA */}
      {isConnected ? (
        <button className="sr-btn-primary" onClick={onBegin}>
          Begin deposit
        </button>
      ) : (
        <>
          <button
            className="sr-btn-primary"
            onClick={() => setWalletDialogOpen(true)}
          >
            Connect wallet
          </button>
          <WalletConnectDialog
            open={walletDialogOpen}
            onClose={() => setWalletDialogOpen(false)}
          />
        </>
      )}
    </>
  );
};
